import React, { useState } from "react";
import { Box, Typography, IconButton, Button, CloseIcon, Link } from "app/material-framework/materialComponents";
import { UserGuideDialog } from "./UserGuideDialog";
import { useTheme } from "@mui/material/styles";
import { getGRP_JAPI_Url } from "../utils/htmlReportsUtils";

export function ChatIntroSection({ onClose, isHtmlReport }) {
  const [openUserGuideDialog, setOpenUserGuideDialog] = useState(false);
  const theme = useTheme();

  const handleOpenUserGuide = () => setOpenUserGuideDialog(true);
  const handleCloseUserGuide = () => setOpenUserGuideDialog(false);

  return (
    <Box sx={{ p: 2, bgcolor: "#F5F5F5", borderBottom: "1px solid #D9D9D9" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
            borderBottom: "1px solid #D9D9D9",
          }}
        >
          NaiRA: Your AI Research Assistant
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close Top Questions">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Get started now.&nbsp;
        <Button
          variant="text"
          onClick={handleOpenUserGuide}
          sx={{ color: "#CA2420", textDecoration: "underline", minWidth: 0, p: 0, textTransform: "none" }}
        >
          NaiRA User Guide
        </Button>
      </Typography>
      {/*  <Typography
        variant="body2"
        sx={{
          mb: 1,
        }}
      >
        NaiRA is your dedicated AI-powered Research Assistant. Access insights effortlessly from Nomura Research content
        from the past 3 months, covering Fixed Income (FI), Foreign Exchange (FX) and Economics (EC).
      </Typography> */}
      <Typography variant="body2" sx={{ color: "#CA2420", minWidth: 0, p: 0, textTransform: "none" }}>
        Please Note: Sensitive PII and MNPI Data is currently prohibited from entry into the NaiRA. For further details
        on usage restrictions please review the &nbsp;
        <Button
          variant="text"
          component={Link}
          href={isHtmlReport ? `${getGRP_JAPI_Url()}/research/m/Disclaimers/naira-disclaimer` : "/research/m/Disclaimers/naira-disclaimer"}
          target="_blank"
          sx={{ color: "#CA2420", textDecoration: "underline", minWidth: 0, p: 0, textTransform: "none" }}
        >
          Acceptable Use Term.
        </Button>
      </Typography>
      {openUserGuideDialog && <UserGuideDialog open={openUserGuideDialog} handleClose={handleCloseUserGuide} />}
    </Box>
  );
}
